import { render, staticRenderFns } from "./PriceTableDialogPrice.vue?vue&type=template&id=978977ca"
import script from "./PriceTableDialogPrice.vue?vue&type=script&lang=js"
export * from "./PriceTableDialogPrice.vue?vue&type=script&lang=js"
import style0 from "./PriceTableDialogPrice.vue?vue&type=style&index=0&id=978977ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports